import React from "react";
import { ConfirmationModalContainer } from "../Modal/ConfirmationModalContainer";
import { getValue } from "../../utils/object.utils";
import { useRemoveBranch } from "../../hooks/branchHooks/branch.hooks";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";

interface Props {
  // branchId: number | string | null;
  branchDetail: any;
  onClose: () => unknown;
  open: boolean;
}
export const RemoveBranchModal = ({ branchDetail, onClose, open }: Props) => {
  const branchId = getValue(branchDetail, "id");
  const branchName = getValue(branchDetail, "name");
  const dispatch = useDispatch();

  const { mutate: removeBranch } = useRemoveBranch({
    onSuccess: () => {
      dispatch(setSuccessMessage("Branch removed successfully."));
    },
    onError: (error) => {
      dispatch(setErrorMessage(parseApiError(error)));
    },
  });

  const handleBranchRemove = () => {
    onClose();

    if (!branchId) return null;

    removeBranch(branchId);
  };

  if (!branchDetail || !branchId) return null;

  return (
    <ConfirmationModalContainer
      show={open}
      onClose={onClose}
      onSubmit={handleBranchRemove}
      isRemoving
    >
      <div>Do you want to remove {branchName} branch?</div>
    </ConfirmationModalContainer>
  );
};
